import { userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    cetsMessageVisible: false,
    isPunchedIn: false,
    isPrevDayAssigned: false,
    isPrev2DayAssigned: false,
    IsDepartmentCetsHardStop: false,
    IsUserExempt: false,
};

export const reducer = createReducer(initialState, {
    [userActions.loginSuccess]: (state, action) => {
        if ((action.payload.isCetsPunchedIn === false) ||
            ((!action.payload.isPreviousDayAssigned ||
                !action.payload.isPreviousDay2Assigned) &&
                (action.payload.isDepartmentCetsHardStop && !action.payload.isUserExempt))) {
            state.cetsMessageVisible = true;
            state.isPunchedIn = action.payload.isCetsPunchedIn;
            state.isPrevDayAssigned = action.payload.isPreviousDayAssigned;
            state.isPrev2DayAssigned = action.payload.isPreviousDay2Assigned;
            state.IsDepartmentCetsHardStop = action.payload.isDepartmentCetsHardStop;
            state.IsUserExempt = action.payload.isUserExempt;
        }
    },
    [userActions.clearCetsMessage]: (state, action) => {
        state.cetsMessageVisible = false;
    },
    [userActions.cetsPunchInRequest]: (state, action) => {
        state.cetsMessageVisible = false;
    },
})